<template>
  <v-card class="revision-card">
    <revision-card-header :revision="revision" />
    <v-divider />
    <v-card-text class="pa-6 d-flex">
      <div class="grid-container flex-grow-1">
        <div class="grid-item border-right">
          <h3>Review Outcome</h3>
          <span class="text-body-2">{{ revisionOutcomeText }}</span>
        </div>
        <div class="grid-item border-right">
          <h3>Evidence Time Frame</h3>
          <span class="text-body-2">{{ evidenceTimeFrameText }}</span>
        </div>
        <div class="grid-item">
          <h3>Reference Breakdown</h3>
          <revision-card-reference-breakdown :revision="revision" />
        </div>
      </div>
    </v-card-text>
    <v-divider />
    <revision-card-actions
      :revision="revision"
      @show-prisma-stats="$emit('show-prisma-stats', $event)"
      @export-revision="$emit('export-revision', $event)"
      @publish-revision="$emit('publish-revision', $event)"
    />
  </v-card>
</template>

<script>
import RevisionCardHeader from './RevisionCardHeader';
import RevisionCardActions from './RevisionCardActions';
import RevisionCardReferenceBreakdown from './RevisionCardReferenceBreakdown';
import { Revision } from '@/models';
import { RevisionOutcome } from '@/enums';
import { format } from 'date-fns';

const DATE_FORMAT = 'd MMM yyyy';

export default {
  name: 'RevisionCard',
  components: {
    RevisionCardHeader,
    RevisionCardActions,
    RevisionCardReferenceBreakdown,
  },
  props: {
    revision: {
      type: Revision,
      required: true,
    },
  },
  emits: ['show-prisma-stats', 'export-revision', 'publish-revision'],
  computed: {
    revisionOutcomeText() {
      switch (this.revision.outcome) {
        case RevisionOutcome.NO_NEW_EVIDENCE:
          return 'No new evidence';
        case RevisionOutcome.NEW_EVIDENCE_NO_IMPACT:
          return 'Evidence found, no impact';
        case RevisionOutcome.NEW_EVIDENCE_IMPACTFUL:
          return 'Impactful evidence found, integrate';
        default:
          return '-';
      }
    },
    evidenceTimeFrameText() {
      const startDate = this.revision.createdAt;
      const formattedStartDate = format(startDate, DATE_FORMAT);
      const formattedEndDate = this.revision.isPublished
        ? format(this.revision.publishedAt, DATE_FORMAT)
        : 'Now';

      return `${formattedStartDate} - ${formattedEndDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.revision-card {
  .grid-container {
    display: grid;
    grid-template-columns: 220px 250px 1fr;

    .grid-item:not(:first-child) {
      padding: 0 26px;
    }

    .grid-item:first-child {
      padding-right: 26px;
    }

    .grid-item > h3 {
      @extend .subtitle-1,
        .grey--text,
        .text--darken-2,
        .font-weight-bold,
        .mb-2;
    }
  }

  .border-right {
    border-right: 1px solid map-get($grey, 'lighten-2');
  }

  .progress-bar {
    width: 150px;
  }
}
</style>
